import React, { Component } from "react";
import { Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// import { logout } from '../actions/auth';

// import './dashboard.css';
// import Dashboard from "./dashboard";
import cx from 'classnames';
import ResizeDetector from 'react-resize-detector';

import Blogs from "./blogs.component";
import EditBlogs from "./editBlog";
import Users from "./users";
import Roles from "./roles";
import Statics from "./statics";
import Devices from "./devices";
import Attendence from "./attendence";
import ViewAttendence from "./viewAttendance";

import AppHeader from '../Layout/AppHeader/';
import AppSidebar from '../Layout/AppSidebar/';
import AppFooter from '../Layout/AppFooter/';
// import Main from "./Components/home.component";

class Home extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      width: undefined
    }
  }
  onResize = (width) => this.setState({ width });

  render() {
    let {
      colorScheme,
      enableFixedHeader,
      enableFixedSidebar,
      enableFixedFooter,
      enableClosedSidebar,
      closedSmallerSidebar,
      enableMobileMenu,
      // enablePageTabsAlt,
    } = this.props;
    const { width } = this.state;

    // console.log("RENDERING HOME.JS")
    // return (
    //   <div>
    //     {/* <TopBar _userName={this.props.userName} /> */}
    //     <div className="container-fluid">
    //       <div className="row">
    //         <Sidebar />
    //         <main role="main" className="col-md-9 ml-sm-auto col-lg-10 px-4">
    //           {/* <div className="chartjs-size-monitor" style={{ position: 'absolute', left: '0px', top: '0px', right: '0px', bottom: '0px', overflow: 'hidden', 'pointerEvents': 'none', visibility: 'hidden', 'zIndex': '-1' }}>
    //             <div className="chartjs-size-monitor-expand" style={{ position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, overflow: 'hidden', 'pointerEvents': 'none', visibility: 'hidden', 'zIndex': -1 }}>
    //               <div style={{ position: 'absolute', width: '1000000px', height: '1000000px', left: 0, top: 0 }}>
    //               </div>
    //             </div>
    //             <div className="chartjs-size-monitor-shrink" style={{ position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, overflow: 'hidden', 'pointerEvents': 'none', visibility: 'hidden', zIndex: -1 }}>
    //               <div style={{ position: 'absolute', width: '200%', height: '200%', left: 0, top: 0 }}>
    //               </div>
    //             </div>
    //           </div> */}
    //           {/* <Dashboard /> */}
    //           {/* <Route path="/main/dashboard" component={Dashboard} />
    //           <Route path="/main/blogs" component={Blogs} />
    //           <Route path="/main/users" component={Users} />
    //           <Route path="/main/roles" component={Roles} /> */}

    //         </main>
    //       </div>

    //     </div>
    //   </div>
    // );
    return (
      <>
        <div className={cx(
          "app-container app-theme-" + colorScheme,
          { 'fixed-header': enableFixedHeader },
          { 'fixed-sidebar': enableFixedSidebar || width < 1250 },
          { 'fixed-footer': enableFixedFooter },
          { 'closed-sidebar': enableClosedSidebar || width < 1250 },
          { 'closed-sidebar-mobile': closedSmallerSidebar || width < 1250 },
          { 'sidebar-mobile-open': enableMobileMenu },
        )}>
          <AppHeader />
          <div className="app-main">
            <AppSidebar />
            <div className="app-main__outer">
              <div className="app-main__inner">
                <Route path="/main/blogs" component={Blogs} />
                <Route path="/main/users" component={Users} />
                <Route path="/main/roles" component={Roles} />
                <Route path="/main/edit_blogs" component={EditBlogs} />
                <Route path="/main/manage_statics" component={Statics} />
                <Route path="/main/devices" component={Devices} />
                <Route path="/main/attendance" component={Attendence} />
                <Route path="/main/viewAttendance" component={ViewAttendence} />
              </div>
              <AppFooter />
            </div>
          </div>
          <ResizeDetector handleWidth onResize={this.onResize} />

        </div>
      </>
    )
  }
}


// function Dashboard() {
//   console.log("RENDERING DASHBOARD.JS")
//   return (
//     <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
//       <h1 className="h2">Dashboard</h1>
//       <div className="btn-toolbar mb-2 mb-md-0">
//         <div className="btn-group mr-2">
//           <button className="btn btn-sm btn-outline-secondary">Share</button>
//           <button className="btn btn-sm btn-outline-secondary">Export</button>
//         </div>
//         <button className="btn btn-sm btn-outline-secondary dropdown-toggle">
//           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="'none'" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-calendar"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
//           This week
//         </button>
//       </div>
//     </div>
//   )
// }
// function Sidebar() {
//   console.log("RENDERING SIDEBAR.JS")
//   return (
//     <nav id="sidebar" className="col-md-2 d-'none' d-md-block bg-light sidebar">
//       <div className="sidebar-sticky" style={{ "textAlign": "left" }}>
//         <ul className="nav flex-column">
//           {/* <li className="nav-item">
//             <a className="nav-link active" href="/dummy">
//               <img src="/assets/icons/dashboard.svg" alt="dashboard" style={{ height: 25, width: 24 }} />
//               Dashboard <span className="sr-only">(current)</span>
//             </a>
//           </li> */}
//           <li className="nav-item">
//             <Link className="nav-link" to="/main/blogs">
//               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="'none'" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-file"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg>
//               Blogs
//             </Link>
//           </li>
//           <li className="nav-item">
//             <Link className="nav-link" to="/main/users">
//               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="'none'" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-users"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
//               Users
//             </Link>
//           </li>

//           <li className="nav-item">
//             <Link className="nav-link" to="/main/roles">
//               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="'none'" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-users"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 9-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
//               Roles
//             </Link>
//           </li>
//         </ul>
//       </div>
//     </nav>

//   )
// }

// function Topbar(props) {
//   console.log("RENDERING TOPBAR.JS")
//   return (
//     <nav className="navbar navbar-dark navbar-expand-lg bg-dark fixed-top">
//       <span className="navbar-brand mb-0 h1" href="/dummy">Montel Admin</span>
//       <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
//         <span className="navbar-toggler-icon"></span>
//       </button>
//       <div className="container">

//         <div className="collapse navbar-collapse" id="navbarSupportedContent">
//           <ul className="navbar-nav ml-auto">
//             <li className="nav-item">
//               <button className="btn btn-danger mr-2 d-none d-lg-inline text-white" onClick={() => props.logout && props.logout()}>Logout</button>
//               <span className="mr-2 d-none d-lg-inline text-white">Hi, {props.user.name}</span>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </nav>


//   )
// }
// const TopBar = connect(({ user }) => ({ user }), { logout })(Topbar)

const mapStateToProp = state => ({
  colorScheme: state.ThemeOptions.colorScheme,
  enableFixedHeader: state.ThemeOptions.enableFixedHeader,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableFixedFooter: state.ThemeOptions.enableFixedFooter,
  enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt,

});

export default withRouter(connect(mapStateToProp)(Home));